import React from "react";

function ButtonList() {
    return (
        <div className="p-2 m-2">
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                All
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Music
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Mixes
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Gaming
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Cooking
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Soccer
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Cricket
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Sports
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                Bollywood Music
            </button>
            <button className="rounded-lg text-sm  px-4 py-1 mx-2 border bg-gray-50">
                News
            </button>
        </div>
    );
}

export default ButtonList;
